<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12">

                <!-- Header -->
                <v-card class="rounded-xl elevation-2 px-3 py-2 mb-3">
                    <div class="d-flex align-center">
                        <v-btn icon small text color="primary" @click="chiudi()">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <div class="ml-2 flex-grow-1">
                            <div class="text-subtitle-2 font-weight-bold primary--text">
                                {{ isNuovo ? 'Appuntamento esterno congregazione fuori circoscrizione' : 'Modifica appuntamento esterno fuori circoscrizione' }}
                            </div>
                            <div v-if="dataLocale" class="text-caption grey--text text-capitalize">{{ dataLocale }}</div>
                        </div>
                        <v-icon color="primary" size="28">mdi-earth</v-icon>
                    </div>
                </v-card>

                <!-- Skeleton loader -->
                <v-card v-if="loading" class="rounded-xl elevation-2 pa-4">
                    <v-skeleton-loader type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, actions" />
                </v-card>

                <!-- Form -->
                <v-card v-else class="rounded-xl elevation-2">
                    <v-card-text class="pt-4 pb-2">
                        <v-form v-model="valid" ref="formProgramma" lazy-validation>

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-home-city-outline</v-icon>
                                Congregazione
                            </div>
                            <v-text-field
                                v-model="programma.congregazioneExtra"
                                outlined rounded dense
                                :rules="congregazioneRules"
                                placeholder="Nome congregazione"
                                class="mb-1"
                            />

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-account-outline</v-icon>
                                Oratore
                            </div>
                            <v-select
                                v-model="programma.oratore.id"
                                :items="oratoriExtra"
                                item-text="oratore.nominativo"
                                item-value="oratore.id"
                                outlined rounded dense
                                :rules="oratoreRules"
                                placeholder="Seleziona oratore"
                                :loading="loadingOratori"
                                :no-data-text="loadingOratori ? 'Caricamento...' : 'Nessun oratore esterno trovato'"
                                class="mb-1"
                            />

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-book-open-outline</v-icon>
                                Schema
                            </div>
                            <v-autocomplete
                                v-model="programma.discorso.id"
                                :items="schemi"
                                :rules="schemaRules"
                                :item-text="s => s.discorso ? ((s.discorso.diId === 99999 ? '-' : s.discorso.diId) + ' ' + s.discorso.tema) : ''"
                                item-value="discorso.id"
                                :filter="(item, q) => { const s = q.toLowerCase(); const d = item.discorso||{}; return String(d.diId===99999?'-':d.diId||'').includes(s)||(d.tema||'').toLowerCase().includes(s); }"
                                outlined rounded dense
                                placeholder="Cerca per numero o testo..."
                                :loading="loadingSchemi"
                                :no-data-text="loadingSchemi ? 'Caricamento...' : 'Selezionare prima l\'oratore'"
                                class="mb-1"
                            >
                                <template v-slot:selection="{ item }">
                                    <div class="d-flex align-start py-1" style="white-space:normal;word-break:break-word;min-width:0;width:100%">
                                        <span class="numero-schema mr-2 flex-shrink-0">{{ item.discorso.diId === 99999 ? '-' : (item.discorso.numero ? item.discorso.numero.trim() : item.discorso.diId) }}</span>
                                        <span style="white-space:normal">{{ item.discorso.tema }}</span>
                                    </div>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <v-list-item-title class="d-flex align-center">
                                            <span class="numero-schema mr-2">{{ item.discorso.diId === 99999 ? '-' : (item.discorso.numero ? item.discorso.numero.trim() : item.discorso.diId) }}</span>
                                            {{ item.discorso.tema }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>

                            <div class="field-label">
                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-music-note</v-icon>
                                Cantico
                            </div>
                            <v-text-field
                                v-model="programma.cantico"
                                outlined rounded dense
                                placeholder="Numero cantico"
                            />

                        </v-form>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions class="px-4 py-3">
                        <v-btn text rounded @click="chiudi()">Annulla</v-btn>
                        <v-spacer />
                        <v-btn color="primary" rounded depressed :loading="loading" :disabled="!valid" @click="saveProgramma">
                            {{ isNuovo ? 'Salva' : 'Aggiorna' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { callService, callPost, gLocalData } from '@/modules/utilities.js';
import { VSkeletonLoader } from 'vuetify/lib';
import { bus } from '@/main.js';

export default {
    components: { VSkeletonLoader },
    props: {
        inlineId:              { default: null },
        inlineData:            { default: null },
        inlineIdCongregazione: { type: String, default: null },
    },
    data: () => ({
        loading: false,
        valid: false,
        defaultProgramma: {
            id: null,
            data: null,
            isExtra: true,
            congregazioneExtra: null,
            oratore: {
                id: null
            },
            discorso: {
                id: null
            },
            cantico: null
        },
        programma: {},
        dataLocale: '',
        schemi: [],
        oratoriExtra: [],
        loadingOratori: false,
        loadingSchemi: false,
        isNuovo: false,
        schemaRules: [
          v => !!v || 'Lo schema è obbligatorio'
        ],
        congregazioneRules: [
          v => !!v || 'La congregazione è obbligatoria'
        ],
        oratoreRules: [
          v => !!v || 'L\'oratore è obbligatorio'
        ]
    }),
    computed: {
        isInline() {
            return this.inlineId !== null || this.inlineData !== null;
        },
        idCongregazioneAttiva() {
            return this.inlineIdCongregazione
                || this.$route?.query?.idCong
                || this.$store.state.idCongregazione;
        },
    },
    async mounted() {
        if (this.isInline) await this.loadInline();
    },
    watch: {
        inlineId(val) { if (val !== null) this.loadInline(); },
        inlineData(val) { if (val !== null) this.loadInline(); },
        '$route.params': {
            immediate: true,
            async handler(params) {
                if (this.isInline) return;
                this.isNuovo = !params.id;
                if (this.isNuovo) {
                    // Resetta il programma a un oggetto pulito con una COPIA PROFONDA
                    this.programma = JSON.parse(JSON.stringify(this.defaultProgramma));
                    this.programma.congregazione= {id : 0};
                    this.programma.congregazioneEsterna = {id : this.idCongregazioneAttiva};

                    if (this.$route.query.data) {
                        this.programma.data = new Date(this.$route.query.data);
                        this.dataLocale = this.localData(this.programma.data);
                        this.fetchOratori();
                    }
                    
                    // Aggiunto: aspetta il prossimo tick e poi resetta la validazione della form
                    this.$nextTick(() => {
                        if (this.$refs.formProgramma) {
                            this.$refs.formProgramma.resetValidation();
                        }
                    });

                } else {
                    // Altrimenti, recupera i dati del programma esistente
                    this.fetchProgramma(params.id);
                }
            }
        },
        'programma.oratore.id': {
            handler(newOratoreId) {
                // Resetta esplicitamente il discorso ogni volta che cambia l'oratore
                let id = this.programma.discorso.id;
                this.programma.discorso.id = null;
                this.schemi = [];

                if (!newOratoreId) {
                    this.programma.congregazioneExtra = null;
                    return;
                }
                const selectedOratore = this.oratoriExtra.find(o => o.oratore.id === newOratoreId);
                if (selectedOratore && selectedOratore.congregazione) {
                    this.programma.congregazioneExtra = selectedOratore.congregazione.nome;
                }
                this.fetchSchemi(newOratoreId);
                this.programma.discorso.id = id;

            }
        }
    },
    methods: {
        chiudi() {
            if (this.isInline) this.$emit('close');
            else this.$router.back();
        },
        async loadInline_byId(id) {
            this.fetchProgramma(id);
        },
        async loadInline() {
            this.isNuovo = !this.inlineId;
            if (this.isNuovo) {
                this.programma = JSON.parse(JSON.stringify(this.defaultProgramma));
                this.programma.congregazione = { id: 0 };
                this.programma.congregazioneEsterna = { id: this.idCongregazioneAttiva };
                if (this.inlineData) {
                    this.programma.data = new Date(this.inlineData);
                    this.dataLocale = this.localData(this.programma.data);
                    this.fetchOratori();
                }
                this.$nextTick(() => {
                    if (this.$refs.formProgramma) this.$refs.formProgramma.resetValidation();
                });
            } else {
                this.fetchProgramma(this.inlineId);
            }
        },
        localData(v) {
            return gLocalData(v);
        },
        async fetchProgramma(id) {
            this.loading = true;
            try {
                const params = [
                    this.$store.state.idCircoscrizione,
                    this.idCongregazioneAttiva,
                ];
                const [programma] = await callService(`/api/Programma/esterno?idProgramma=${encodeURIComponent(id)}`, params);
                this.programma = programma;
                this.dataLocale = this.localData(programma.data);
                
                await this.fetchOratori();
                
                // Imposta il valore del v-select dopo aver caricato la lista degli oratori
                if (this.programma.oratore && this.programma.oratore.id) {
                    this.programma.oratore.id = this.programma.oratore.id;
                }

            } catch (error) {
                console.error('Errore durante il recupero dei dati del programma extra:', error);
            } finally {
                this.loading = false;
            }
        },
        async fetchOratori() {
            this.loadingOratori = true;
            try {
                let paramJson = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.oratore.codice,
                    token: this.$store.state.oratore.token,
                    idCircoscrizione: this.$store.state.idCircoscrizione,
                    idDiscorso: '-1',
                    data: this.programma.data,
                    idCongregazioneAppartenenza: this.idCongregazioneAttiva,
                    idCongregazioneArrivo: '-1',
                    soloDisponibili: false,
                    soloRiserva: false
                };

                const oratori = await callPost(`/api/Oratore/listaOratoreData`, paramJson);
                this.oratoriExtra = oratori;
            } catch (error) {
                console.error('Errore durante il recupero degli oratori extra:', error);
            } finally {
                this.loadingOratori = false;
            }
        },
        async fetchSchemi(idOratore) {
            this.loadingSchemi = true;
            try {
                // listaInfo con idOratore: inserisce "da stabilire" in testa automaticamente
                const lista = await callService(`/api/discorso/listaInfo?idOratore=${encodeURIComponent(idOratore)}`, [
                    this.$store.state.idCircoscrizione,
                    this.idCongregazioneAttiva,
                    false,  // isInterno
                    false,  // ultimoAnno
                ]) || [];
                this.schemi = lista;
            } catch (error) {
                console.error('Errore durante il recupero degli schemi:', error);
            } finally {
                this.loadingSchemi = false;
            }
        },
        async saveProgramma() {
            if (!this.$refs.formProgramma.validate()) {
                return;
            }
            this.loading = true;
            try {
                let paramJson = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.oratore.codice,
                    token: this.$store.state.oratore.token,
                    idCircoscrizione: this.$store.state.idCircoscrizione,
                    programma: this.programma,
                    interno: false
                };

                let service = "";
                service= this.isNuovo ? "salva":"aggiorna";

                const response = await callPost(`/api/programma/`+service, paramJson);
                
                bus.$emit(this.isNuovo ? 'add-programma' : 'update-programma', response);
                if (this.isInline) {
                    await this.loadInline_byId(response.id);
                } else {
                    this.chiudi();
                }

            } catch (error) {
                console.error('Errore durante il salvataggio:', error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0,0,0,0.55);
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}
.theme--dark .field-label {
    color: rgba(255,255,255,0.5);
}
.numero-schema {
    font-size: 0.72rem;
    font-weight: 700;
    padding: 1px 7px;
    border-radius: 6px;
    background-color: rgba(0,0,0,0.08);
    white-space: nowrap;
}
.theme--dark .numero-schema {
    background-color: rgba(255,255,255,0.12);
}
</style>    